import React from "react";
import SEO from "./SEO";
import Header from "./Header";
import Footer from "./Footer";
import ServiceSide from "./ServiceSide";
import { NavLink } from "react-router-dom";

function Services() {
  return (
    <>
      <SEO
        title="Graphic Design Services | Logos, Branding, Ui/Ux & Motion Graphics – Moironix"
        description="Moironix Offers Professional Graphic Design Services, Including Branding, Ui/Ux, Motion Graphics, and Logo Design. Elevate Your Visual Identity Today!"
        keywords="Graphic Design, Logo Design, Infographic Design Services, Brand Identity Design Package, Print Design Services, Ui/Ux Graphic Design, Motion Graphic Design Services, Graphic Design Services, Brand Design, Graphic Designers, Ui/Ux Design, Web Graphic Design"
      />
      <Header />
      <div className="prt-page-title-row style1">
        <div className="prt-page-title-row-inner">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="prt-page-title-row-heading">
                  <div className="banner-vertical-block" />
                  <div className="page-title-heading">
                    <h2 className="title">Graphic Design</h2>
                  </div>
                  <div className="breadcrumb-wrapper">
                    <span>
                      <NavLink title="Homepage" to="/">
                        Home
                      </NavLink>
                    </span>
                    <span className="action">Graphic Design</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <>
        <div className="site-main">
          <div className="prt-row sidebar prt-sidebar-left clearfix">
            <div className="container">
              <div className="row">
                <div className="widget-area sidebar-left prtcol-bgcolor-yes prt-bg prt-left-span bg-base-grey">
                  <ServiceSide />
                </div>
                <div className="col-lg-8 content-area">
                  <div className="prt-service-single-content-area">
                    <div className="prt_fatured_image-wrapper mb-40 res-575-mb-20">
                      <img
                        width={859}
                        height={440}
                        className="img-fluid"
                        src="images/d5.jpeg"
                        alt="services-1"
                      />
                    </div>
                    <div className="prt-service-description">
                      <h3>Graphic Design</h3>
                      <p>
                        At Moironix Soft Solutions, we bring your ideas to life
                        through exceptional graphic design. Our team of creative
                        professionals specializes in crafting visually stunning
                        designs that effectively communicate your brand's
                        message. We offer a comprehensive range of graphic
                        design services, tailored to meet your specific needs,
                        including:
                      </p>
                      <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                          <ul className="service-detail-list">
                            <li className="service-detail-list-item">
                              <div className="service-detail-list-text">
                                Logo Design
                              </div>
                            </li>
                            <li className="service-detail-list-item">
                              <div className="service-detail-list-text">
                                Brand Identity
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                          <div>
                            <ul className="service-detail-list">
                              <li className="service-detail-list-item">
                                <div className="service-detail-list-text">
                                  Marketing Materials
                                </div>
                              </li>
                              <li className="service-detail-list-item">
                                <div className="service-detail-list-text">
                                  Web and Digital Graphics
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                          <div>
                            <ul className="service-detail-list">
                              <li className="service-detail-list-item">
                                <div className="service-detail-list-text">
                                  Infographics
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                          <div>
                            <ul className="service-detail-list">
                              <li className="service-detail-list-item">
                                <div className="service-detail-list-text">
                                  Illustrations
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
      <Footer />
    </>
  );
}

export default Services;
